import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import CategorisationCategoryFields from "./forms/CategorisationCategoryFields";
import CategorisationFinancialFields from "./forms/CategorisationFinancialFields";
import CategorisationOtherFields from "./forms/CategorisationOtherFields";
import { FormattedMessage } from "react-intl";
import { reduxForm } from "redux-form";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../../../utils/data/dataActions";
import { CLIENT_CLASSIFICATION, CLIENT_V2 } from "../../../../../utils/data/models";
import { TERMINATED } from "../../enums/clientStatusTypes";
import validationUtils from "../../../../../utils/ValidationUtils";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FINTECH } from "../../../../../utils/Roles";
import { SIMPLE_FETCH_ERRORS } from "../../../../common/enums/simpleFetchErrorType";

class CategorisationForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.resetForm = this.resetForm.bind(this);
        this.handleSubmitForm = _.debounce(this.handleSubmitForm.bind(this), 350);
        this.incrementRefreshInitialValues = this.incrementRefreshInitialValues.bind(this);

        this.state = {
            refreshInitialValues: 0,
            submitting: false,
        };
    }

    resetForm(values = null, error = false) {
        const { initialize, initialValues } = this.props;

        if (!values) {
            initialize(initialValues);
        } else {
            initialize(values);
        }
        if (!error) {
            this.incrementRefreshInitialValues();
        }
    }

    incrementRefreshInitialValues() {
        this.setState((prevState) => {
            return {
                ...prevState,
                refreshInitialValues: prevState.refreshInitialValues + 1,
            };
        });
    }

    handleSubmitForm(values) {
        const { clientId, dataActions, setInitialValuesIsSet } = this.props;

        this.setState({ submitting: true });
        setInitialValuesIsSet(false);

        const model = {
            ...CLIENT_CLASSIFICATION,
            path: CLIENT_CLASSIFICATION.path.replace("{}", clientId),
        };
        values.clientId = clientId;
        values.seller = values.seller ? values.seller.trim() : values.seller;

        dataActions.createDataItem(model, values).then((res) => {
            if (res.type === "CREATE_DATA_ITEM_SUCCESS") {
                toast(<FormattedMessage id="genericSaveSuccess" />, {
                    type: toast.TYPE.SUCCESS,
                    autoClose: 5000,
                });
                this.setState({ submitting: false }, () => {
                    this.props.getData(this.resetForm);
                });
                this.props.dataActions.getDataItem(CLIENT_V2, clientId);
            } else if (res.type === "CREATE_DATA_ITEM_FAILURE") {
                const { error } = res.payload;
                if (error && error.data) {
                    const errorCode = error.data.message && error.data.message.errorCode;
                    if (error.data.error === "missing_field_error") {
                        toast(
                            <FormattedMessage id="clients.client.categorisation.categoryForm.form.missingFieldsError" />,
                            {
                                type: toast.TYPE.ERROR,
                                autoClose: false,
                            }
                        );
                    }
                    else if (!SIMPLE_FETCH_ERRORS.includes(errorCode)) {
                        toast(
                            <FormattedMessage id="genericSaveError" />,
                            {
                                type: toast.TYPE.ERROR,
                                autoClose: false,
                            }
                        );
                    }
                    this.setState({ submitting: false }, () => {
                        this.props.getData(this.resetForm(values, true));
                    });
                }
            } else {
                toast(<FormattedMessage id="genericSaveError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
                this.setState({ submitting: false }, () => {
                    this.props.getData(this.resetForm(values, true));
                });
            }
        });
    }

    render() {
        const { pristine, handleSubmit, initialValues, initialValuesIsSet, clientId, activeClient } = this.props;
        const { refreshInitialValues, submitting } = this.state;

        const disableBtns = pristine || submitting || !initialValuesIsSet;
        const required = false
        const isTerminatedClient = activeClient && activeClient.clientStatusType === TERMINATED.value && !userHasAccess(FINTECH);

        return (
            <form onSubmit={handleSubmit(this.handleSubmitForm)}>
                <fieldset disabled={isTerminatedClient}>
                    <div className="flex-category-section">
                        <CategorisationCategoryFields
                            refreshInitialValues={refreshInitialValues}
                            initialValues={initialValues}
                            clientId={clientId}
                            required={required}
                            disabled={isTerminatedClient}
                        />
                        <div>
                            <CategorisationFinancialFields required={required} clientId={clientId} />
                            <CategorisationOtherFields />
                            <div className="config-form-btns">
                                <button
                                    disabled={disableBtns}
                                    onClick={() => this.resetForm()}
                                    type="button"
                                    className="btn btn-lg btn-primary mt-1"
                                >
                                    <FormattedMessage id="clients.client.categorisation.cancelBtn" />
                                </button>
                                <button disabled={disableBtns} type="submit" className="btn btn-lg btn-primary mt-1">
                                    <FormattedMessage id="clients.client.categorisation.saveBtn" />
                                </button>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>
        );
    }
}

const validate = (values) => {
    const vipClientRule = {
        vipClassification: {
            isRequiredTrimIfFieldHasValue: {
                value: {
                    field: "vipClient",
                    expectedValues: [true],
                },
            },
        },
    };
    return validationUtils.validate(values, vipClientRule);
};

CategorisationForm.propTypes = {
    clientClassification: PropTypes.object,
    initialValues: PropTypes.object,
    pristine: PropTypes.bool,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    clientId: PropTypes.number,
    dataActions: PropTypes.object,
    getData: PropTypes.func,
    initialValuesIsSet: PropTypes.bool,
    initialize: PropTypes.func,
    activeClient: PropTypes.object,
    setInitialValuesIsSet: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

function mapStateToProps(state) {
    const { clientClassification, submitting, clients } = state.data;

    return {
        clientClassification: clientClassification.active,
        submitting: submitting,
        activeClient: clients.active,
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: "categorisationForm",
        validate,
    })(CategorisationForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/CategorisationForm.js